import React from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { FaInstagram, FaTiktok } from "react-icons/fa";

import Kaizen from "../../assets/images/kaizenLogoo.png";
import Obsessed from "../../assets/images/obsessed.png";
import { useSelector } from "react-redux";
import { selectCategories } from "../../store/slices/products/slice";

const Footer = () => {
  const navigate = useNavigate();
  const categories = useSelector(selectCategories);

  return (
    <FooterContainer>
      <FooterWrapper>
        <Column>
          <LogoContainer>
            <Logo src={Kaizen} />
            <Logo src={Obsessed} />
          </LogoContainer>
          <CopyText>
            Gym wear brend iz Novog Sada. Kaizen filozofija — konstantno, malo,
            bolje.
          </CopyText>
        </Column>

        <Column>
          <SectionTitle>Navigacija</SectionTitle>
          <NavLinks>
            <Link
              onClick={() => {
                navigate("/o-nama");
                setTimeout(() => {
                  window.scrollTo(0, 0);
                }, 300);
              }}
            >
              O nama
            </Link>
            <Link
              onClick={() => {
                navigate("/dostava");
                setTimeout(() => {
                  window.scrollTo(0, 0);
                }, 300);
              }}
            >
              Dostava
            </Link>
            <Link
              onClick={() => {
                navigate("/prodavnica", { state: { kategorija: "Sve" } });
                setTimeout(() => {
                  window.scrollTo(0, 0);
                }, 300);
              }}
            >
              Prodavnica
            </Link>
          </NavLinks>
        </Column>

        <Column>
          <SectionTitle>Brzi linkovi</SectionTitle>
          <NavLinks>
            {categories.data.map((ctg, index) => (
              <Link
                onClick={() => {
                  navigate("/prodavnica", { state: { kategorija: ctg.name } });
                  setTimeout(() => {
                    window.scrollTo(0, 0);
                  }, 300);
                }}
                key={ctg.id ?? ctg.name}
              >
                {ctg.name}
              </Link>
            ))}
          </NavLinks>
        </Column>

        <Column>
          <SectionTitle>Informacije</SectionTitle>
          <CopyText style={{ marginTop: -18, fontSize: 10 }}>
            Moguće lično preuzimanje u Novom Sadu
          </CopyText>
          <SocialMediaRow style={{ justifyContent: "space-between" }}>
            <Column>
              <SectionTitle>Zapratite nas</SectionTitle>
              <SocialMediaRow>
                <FaInstagram
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/obsessed.rs/",
                      "_blank"
                    )
                  }
                />
                <FaTiktok
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open("https://www.tiktok.com/@obsessed.rs", "_blank")
                  }
                />
              </SocialMediaRow>
            </Column>
          </SocialMediaRow>
        </Column>
      </FooterWrapper>

      <CopyRow>
        <span>
          © {new Date().getFullYear()} Obsessed Inc. Sva prava zadržana.
        </span>
        <span>改善 — Kaizen</span>
      </CopyRow>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.footer`
  color: var(--text, #f4f2ee);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-top: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  background: var(--bg0, #0a0a0c);
  padding-bottom: 12rem;
`;

const CopyRow = styled.div`
  width: 100%;
  max-width: 120rem;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 2rem 2rem 0;
  border-top: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  color: var(--muted2, #5c5a63);
  font-size: 1.1rem;
  font-family: "Poppins-Regular";
  letter-spacing: 0.08em;

  @media (max-width: 961px) {
    justify-content: center;
    text-align: center;
  }
`;

const FooterWrapper = styled.div`
  max-width: 120rem;
  width: 100%;
  display: flex;
  gap: 5rem;
  padding: 4rem 2rem;
  justify-content: space-between;

  @media (max-width: 961px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media (max-width: 961px) {
    justify-content: center;
    align-items: center;
  }
`;

const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (max-width: 961px) {
    text-align: center;
  }
`;

const SectionTitle = styled.p`
  font-size: 1.2rem;
  letter-spacing: 0.24em;
  font-family: "Poppins-SemiBold";
  text-transform: uppercase;
  color: var(--red, #fe5f55);
  @media (max-width: 961px) {
    text-align: center;
  }
`;

const SocialMediaRow = styled.div`
  display: flex;
  gap: 1.5rem;
  font-size: 1.5rem;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
`;

const CopyText = styled.p`
  font-size: 1.2rem;
  color: var(--muted, #8e8c94);
  font-family: "Poppins-Regular";
  max-width: 28rem;
  line-height: 1.6;
  @media (max-width: 961px) {
    margin-top: -1rem !important;
  }
`;

const underline = keyframes`
  from {
    width: 0;
    left: 50%;
  }
  to {
    width: 100%;
    left: 0;
  }
`;

const Link = styled.span`
  color: var(--muted, #8e8c94);
  font-size: 1.3rem;
  font-family: "Poppins-Medium";
  position: relative;
  cursor: pointer;
  transition: color 0.3s ease;

  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 50%;
    height: 2px;
    background-color: #fe5f55;
    width: 0%;
    transition: all 0.3s ease;
  }

  &:hover {
    color: #fe5f55;
  }

  &:hover::after {
    animation: ${underline} 0.3s forwards;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  align-items: center;
  gap: 0.5rem;
`;

const Logo = styled.img`
  height: 5rem;
  width: auto;
  @media (max-width: 400px) {
    height: 4rem;
  }
`;
